import React from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Code2, LogOut, Menu, X } from 'lucide-react';
import { useAuthStore } from '../store/auth';

const Navbar = () => {
  const { user, isAdmin, signOut } = useAuthStore();
  const [menuOpen, setMenuOpen] = useState(false);
  const profileImage = user?.user_metadata?.avatar_url;

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <nav className="bg-white border-b shadow-md">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="text-xl font-bold text-indigo-600 flex items-center">
              <Code2 className="inline-block h-6 w-6 mr-2" />
              Codedrop
            </Link>
          </div>
          <div className="hidden md:flex space-x-6 items-center">
            <Link to="/dashboard" className="text-gray-700 hover:text-indigo-600">
              Dashboard
            </Link>
            <Link to="/editor" className="text-gray-700 hover:text-indigo-600">
              Pages
            </Link>
            <Link to="/file-upload" className="text-gray-700 hover:text-indigo-600">
              File Upload
            </Link>
            <Link to="/subscription" className="text-gray-700 hover:text-indigo-600">
              Subscription
            </Link>
            {isAdmin && (
              <Link
                to="/admin"
                className="text-gray-300 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md text-sm font-medium"
              >
                Admin
              </Link>
            )}
            <Link to="/profile" className="flex items-center">
              {profileImage ? (
                <img
                  src={profileImage}
                  alt="Profile"
                  className="h-8 w-8 rounded-full border border-gray-300"
                />
              ) : (
                <div className="w-8 h-8 bg-gray-500 rounded-full" />
              )}
            </Link>
            <button
              onClick={() => signOut()}
              className="text-gray-700 hover:text-indigo-600"
              aria-label="Log out"
            >
              <LogOut className="h-5 w-5" />
            </button>
          </div>
          <div className="md:hidden">
            <button 
              onClick={toggleMenu} 
              className="text-gray-700 hover:text-indigo-600"
              aria-label={menuOpen ? "Close menu" : "Open menu"}
            >
              {menuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>
        {menuOpen && (
          <div className="md:hidden mt-2">
            <div className="flex flex-col space-y-2">
              <Link to="/dashboard" className="text-gray-700 hover:text-indigo-600">
                Dashboard
              </Link>
              <Link to="/editor" className="text-gray-700 hover:text-indigo-600">
                Editor
              </Link>
              <Link to="/file-upload" className="text-gray-700 hover:text-indigo-600">
                File Upload
              </Link>
              <Link to="/subscription" className="text-gray-700 hover:text-indigo-600">
                Subscription
              </Link>
              {isAdmin && (
                <Link
                  to="/admin"
                  className="text-gray-700 hover:text-gray-900 px-3 py-2 rounded-md text-sm font-medium"
                >
                  Admin Dashboard
                </Link>
              )}
              <Link to="/profile" className="flex items-center">
                {profileImage ? (
                  <img
                    src={profileImage}
                    alt="Profile"
                    className="h-8 w-8 rounded-full border border-gray-300"
                  />
                ) : (
                  <div className="w-8 h-8 bg-gray-500 rounded-full" />
                )}
              </Link>
              <button
                onClick={() => signOut()}
                className="text-gray-700 hover:text-indigo-600"
                aria-label="Log out"
              >
                <LogOut className="h-5 w-5" />
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;